const PL = [
	{
		side: 'Home',
		team: 'Leeds United',
		result: '5-1',
		possession: '49 %',
		shots: 16,
		onTarget: 8,
		passes: 422,
		passesCompleted: 334,
		tackles: 4,
		aerial: 11,
	},
	{
		side: 'Away',
		team: 'Southampton',
		result: '1-1',
		possession: '64 %',
		shots: 15,
		onTarget: 4,
		passes: 520,
		passesCompleted: 415,
		tackles: 10,
		aerial: 16,
	},
	{
		side: 'Away',
		team: 'Wolverhampton',
		result: '0-1',
		possession: '56 %',
		shots: 10,
		onTarget: 3,
		passes: 552,
		passesCompleted: 478,
		tackles: 5,
		aerial: 11,
	},
	{
		side: 'Home',
		team: 'Newcastle United',
		result: '4-1',
		possession: '64 %',
		shots: 21,
		onTarget: 7,
		passes: 644,
		passesCompleted: 581,
		tackles: 11,
		aerial: 7,
	},
	{
		side: 'Away',
		team: 'West Ham United',
		result: '1-2',
		possession: '60 %',
		shots: 17,
		onTarget: 10,
		passes: 624,
		passesCompleted: 562,
		tackles: 9,
		aerial: 9,
	},
	{
		side: 'Home',
		team: 'Aston Villa',
		result: '0-1',
		possession: '60 %',
		shots: 28,
		onTarget: 4,
		passes: 409,
		passesCompleted: 313,
		tackles: 8,
		aerial: 19,
	},
	{
		side: 'Home',
		team: 'Everton',
		result: '1-1',
		possession: '72 %',
		shots: 13,
		onTarget: 6,
		passes: 700,
		passesCompleted: 607,
		tackles: 3,
		aerial: 13,
	},
	{
		side: 'Away',
		team: 'Leicester City',
		result: '4-2',
		possession: '51 %',
		shots: 18,
		onTarget: 6,
		passes: 517,
		passesCompleted: 445,
		tackles: 8,
		aerial: 8,
	},
	{
		side: 'Home',
		team: 'Liverpool',
		result: '0-5',
		possession: '37 %',
		shots: 12,
		onTarget: 4,
		passes: 409,
		passesCompleted: 334,
		tackles: 3,
		aerial: 14,
	},
	{
		side: 'Away',
		team: 'Tottenham Hotspur',
		result: '0-3',
		possession: '42 %',
		shots: 10,
		onTarget: 4,
		passes: 421,
		passesCompleted: 339,
		tackles: 12,
		aerial: 13,
	},
	{
		side: 'Home',
		team: 'Manchester City',
		result: '0-2',
		possession: '33 %',
		shots: 5,
		onTarget: 1,
		passes: 400,
		passesCompleted: 326,
		tackles: 11,
		aerial: 9,
	},
	{
		side: 'Away',
		team: 'Watford',
		result: '4-1',
		possession: '61 %',
		shots: 9,
		onTarget: 3,
		passes: 553,
		passesCompleted: 442,
		tackles: 8,
		aerial: 20,
	},
	{
		side: 'Away',
		team: 'Chelsea',
		result: '1-1',
		possession: '34 %',
		shots: 3,
		onTarget: 2,
		passes: 318,
		passesCompleted: 236,
		tackles: 15,
		aerial: 11,
	},
	{
		side: 'Home',
		team: 'Arsenal',
		result: '3-2',
		possession: '45 %',
		shots: 14,
		onTarget: 10,
		passes: 431,
		passesCompleted: 354,
		tackles: 13,
		aerial: 22,
	},
	{
		side: 'Home',
		team: 'Crystal Palace',
		result: '1-0',
		possession: '61 %',
		shots: 16,
		onTarget: 3,
		passes: 530,
		passesCompleted: 436,
		tackles: 11,
		aerial: 17,
	},
	{
		side: 'Away',
		team: 'Norwich City',
		result: '0-1',
		possession: '53 %',
		shots: 13,
		onTarget: 5,
		passes: 501,
		passesCompleted: 409,
		tackles: 10,
		aerial: 21,
	},
	{
		side: 'Away',
		team: 'Newcastle United',
		result: '1-1',
		possession: '69 %',
		shots: 13,
		onTarget: 4,
		passes: 566,
		passesCompleted: 455,
		tackles: 10,
		aerial: 16,
	},
	{
		side: 'Home',
		team: 'Burnley',
		result: '3-1',
		possession: '57 %',
		shots: 18,
		onTarget: 6,
		passes: 484,
		passesCompleted: 377,
		tackles: 5,
		aerial: 21,
	},
	{
		side: 'Home',
		team: 'Wolverhampton',
		result: '0-1',
		possession: '51 %',
		shots: 9,
		onTarget: 2,
		passes: 488,
		passesCompleted: 391,
		tackles: 10,
		aerial: 13,
	},
	{
		side: 'Away',
		team: 'Aston Villa',
		result: '2-2',
		possession: '45 %',
		shots: 13,
		onTarget: 6,
		passes: 451,
		passesCompleted: 368,
		tackles: 11,
		aerial: 12,
	},
	{
		side: 'Away',
		team: 'Brentford',
		result: '1-3',
		possession: '56 %',
		shots: 13,
		onTarget: 5,
		passes: 519,
		passesCompleted: 411,
		tackles: 12,
		aerial: 31,
	},
	{
		side: 'Home',
		team: 'West Ham United',
		result: '1-0',
		possession: '57 %',
		shots: 18,
		onTarget: 3,
		passes: 548,
		passesCompleted: 453,
		tackles: 11,
		aerial: 20,
	},
	{
		side: 'Away',
		team: 'Burnley',
		result: '1-1',
		possession: '64 %',
		shots: 22,
		onTarget: 5,
		passes: 518,
		passesCompleted: 422,
		tackles: 11,
		aerial: 22,
	},
	{
		side: 'Home',
		team: 'Southampton',
		result: '1-1',
		possession: '52 %',
		shots: 12,
		onTarget: 8,
		passes: 469,
		passesCompleted: 382,
		tackles: 7,
		aerial: 18,
	},
	{
		side: 'Home',
		team: 'Brighton & Hove Albion',
		result: '2-0',
		possession: '50 %',
		shots: 19,
		onTarget: 7,
		passes: 512,
		passesCompleted: 418,
		tackles: 10,
		aerial: 14,
	},
	{
		side: 'Away',
		team: 'Leeds United',
		result: '2-4',
		possession: '46 %',
		shots: 15,
		onTarget: 9,
		passes: 340,
		passesCompleted: 247,
		tackles: 10,
		aerial: 7,
	},
	{
		side: 'Home',
		team: 'Watford',
		result: '0-0',
		possession: '67 %',
		shots: 22,
		onTarget: 3,
		passes: 676,
		passesCompleted: 574,
		tackles: 12,
		aerial: 21,
	},
	{
		side: 'Away',
		team: 'Manchester City',
		result: '4-1',
		possession: '31 %',
		shots: 5,
		onTarget: 2,
		passes: 331,
		passesCompleted: 276,
		tackles: 7,
		aerial: 8,
	},
	{
		side: 'Home',
		team: 'Tottenham Hotspur',
		result: '3-2',
		possession: '44 %',
		shots: 10,
		onTarget: 6,
		passes: 459,
		passesCompleted: 391,
		tackles: 9,
		aerial: 10,
	},
	{
		side: 'Home',
		team: 'Leichester City',
		result: '1-1',
		possession: '54 %',
		shots: 11,
		onTarget: 5,
		passes: 582,
		passesCompleted: 500,
		tackles: 6,
		aerial: 12,
	},
	{
		side: 'Away',
		team: 'Everton',
		result: '1-0',
		possession: '68 %',
		shots: 12,
		onTarget: 4,
		passes: 641,
		passesCompleted: 523,
		tackles: 10,
		aerial: 28,
	},
	{
		side: 'Home',
		team: 'Norwich City',
		result: '3-2',
		possession: '61 %',
		shots: 20,
		onTarget: 9,
		passes: 623,
		passesCompleted: 556,
		tackles: 11,
		aerial: 7,
	},
	{
		side: 'Away',
		team: 'Liverpool',
		result: '4-0',
		possession: '28 %',
		shots: 2,
		onTarget: 1,
		passes: 354,
		passesCompleted: 260,
		tackles: 14,
		aerial: 9,
	},
	{
		side: 'Away',
		team: 'Arsenal',
		result: '3-1',
		possession: '45 %',
		shots: 14,
		onTarget: 5,
		passes: 412,
		passesCompleted: 337,
		tackles: 10,
		aerial: 15,
	},
	{
		side: 'Home',
		team: 'Chelsea',
		result: '1-1',
		possession: '35 %',
		shots: 6,
		onTarget: 3,
		passes: 345,
		passesCompleted: 272,
		tackles: 12,
		aerial: 15,
	},
	{
		side: 'Home',
		team: 'Brentford',
		result: '3-0',
		possession: '64 %',
		shots: 9,
		onTarget: 5,
		passes: 714,
		passesCompleted: 651,
		tackles: 8,
		aerial: 15,
	},
	{
		side: 'Away',
		team: 'Brighton & Hove Albion',
		result: '4-0',
		possession: '58 %',
		shots: 15,
		onTarget: 5,
		passes: 495,
		passesCompleted: 417,
		tackles: 10,
		aerial: 12,
	},
	{
		side: 'Away',
		team: 'Crystal Palace',
		result: '1-0',
		possession: '62 %',
		shots: 10,
		onTarget: 4,
		passes: 514,
		passesCompleted: 426,
		tackles: 9,
		aerial: 10,
	},
];

export default PL;
